import AppButton from 'src/components/base/Button/Button';
import MiniCheckBox from 'src/components/modules/MiniCheckBox/MiniCheckBox';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { useDispatch } from 'react-redux';
import { updateIfollowedUpTodo } from 'src/redux/services/loggingServices';
import { Logger } from 'src/latest/src/services/ConsoleLogger';
import { PaymentIssueType, TodoTypeEnums } from 'src/latest/src/constants';
import { useEffect, useState } from 'react';
import { updateUserInfoV1 } from 'src/api/user';
import './PaymentIssueDetectionTodo.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  todo: any;
  onConfirm: () => void;
};

const PaymentIssueDetectionTodo: React.FC<Props> = ({ onConfirm, todo }) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const dispatch = useDispatch();
  const { t } = useTranslation('components');

  const createFollowUp = async () => {
    const respObj = {
      follow_up_by: [TodoTypeEnums.SELF],
      note: ``,
    };

    try {
      setLoading(true);
      await updateIfollowedUpTodo(todo.id, respObj);
      dispatch(clearModalContent());
      onConfirm();
    } catch (e) {
      Logger.log('Follow up error', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!checked) return;

    const patchUserInfo = async () => {
      try {
        const userUpdateObj: any = {
          metadata: {
            ignore_payment_issue_todos: true,
          },
        };

        await updateUserInfoV1(todo.user_id, userUpdateObj);
      } catch (e) {
        Logger.log('Error updating user info', e);
      }
    };

    patchUserInfo();
  }, [checked]);

  return (
    <div className="payment-issue-detection-todo-container">
      <div className="todo-title">
        <p>
          {t('paymentIssueDetectionTodo.titlePrefix')}{' '}
          <b>{todo?.user_full_name}</b>,<br />
          {todo?.metadata?.issue_type ===
          PaymentIssueType.PAYMENT_PLAN_FAILED ? (
            <b>{t('paymentIssueDetectionTodo.paymentPlanFailed')}</b>
          ) : (
            <span>
              {t('paymentIssueDetectionTodo.upcomingAppointmentPrefix')}{' '}
              <b>{todo?.metadata?.$THERAPIST_NAME}</b>:<br />
              <b>{todo?.metadata?.issue_type}</b>
            </span>
          )}
        </p>
      </div>

      <div className="checkbox-container d-flex justify-content-between mt-5 mb-4">
        <MiniCheckBox
          text={t('paymentIssueDetectionTodo.checkbox')}
          isCheckFirst={true}
          isActive={checked}
          onClick={() => setChecked(!checked)}
          value={checked}
        />
      </div>

      <AppButton
        label={t('paymentIssueDetectionTodo.resolvedButton')}
        textWeight="bold"
        textSize="size-14"
        isProcessing={loading}
        className="m-3 clear-todo-button"
        onClick={() => {
          createFollowUp();
        }}
      />
    </div>
  );
};

export default PaymentIssueDetectionTodo;
